import { render, staticRenderFns } from "./TheFamily.vue?vue&type=template&id=594c2c46&scoped=true&"
import script from "./TheFamily.vue?vue&type=script&lang=js&"
export * from "./TheFamily.vue?vue&type=script&lang=js&"
import style0 from "./TheFamily.vue?vue&type=style&index=0&id=594c2c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c2c46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VContent,VFlex,VRow,VSlideXReverseTransition,VSlideXTransition,VSlideYTransition})
